import { useState } from 'react';
import { Link} from 'react-router-dom';
import { Container, Form, Button, Alert, Spinner } from 'react-bootstrap';
import AuthNavbar from '../navbars/AuthNavbar';
import axios from 'axios';

function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const [isSending, setIsSending] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSending(true);
        try {
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth/forgot-password`, { email });
            setMessage('Pokyny na obnovenie hesla boli odoslané na tvoj e-mail. Skontroluj aj SPAM priečinok.');
            setError(null);
        } catch (err) {
            setError(err.response?.data?.detail || 'Chyba pri odosielaní požiadavky.');
            setMessage(null);
        }
        setIsSending(false);
    };

    return (
        <>
            <AuthNavbar />
            <Container className="mt-4">
                <h2 className="text-center">Obnovenie hesla</h2>
                {message && <Alert variant="success">{message}</Alert>}
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>E-mail</Form.Label>
                        <Form.Control type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </Form.Group>
                    <Button type="submit" className="w-100" disabled={isSending}>
                        {isSending && <Spinner as="span" size="sm" className="me-2" />}
                        Odoslať pokyny
                    </Button>
                </Form>


                <div className="d-flex justify-content-between mt-3">
                    <Link to="/login">Späť na prihlásenie</Link>
                    <Link to="/auth/register">Nemáš účet? Zaregistruj sa</Link>
                </div>

            </Container>
        </>
    );
}

export default ForgotPasswordPage;
